import { Box, SxProps, Theme } from '@mui/material';
import { ListQuotes } from 'containers/ListQuotes';
import { Login } from 'containers/Login';
import { Quote } from 'containers/Quote';
import { Unauthorized } from 'containers/Unauthorized';
import { useAppContext } from 'context-providers';
import { ToastContainer } from 'material-react-toastify';
import 'material-react-toastify/dist/ReactToastify.css';
import React, { PropsWithChildren } from 'react';
import { Route, Switch } from 'react-router-dom';
import { useLocation } from 'react-use';
import { AppHeader } from 'shared/components/AppHeader';
import { routes } from 'shared/constants';
import { useAuthState } from 'shared/stores/auth-state';
import { gtag } from 'startup/registerGoogleAnalytics';
import { ProtectedRoute } from './ProtectedRoute';

const appBodyStyles: SxProps<Theme> = {
  width: '100vw',
  height: '100%',
  display: 'flex',
  position: 'relative',
  left: '0',
  top: '0',
  overflow: 'auto',
  paddingLeft: '3%',
  paddingRight: '3%',
  flexDirection: 'column',
};

const PrivateRoute = ({ children }: PropsWithChildren<{}>) => <ProtectedRoute>{children}</ProtectedRoute>;
export const AppRoutes = () => {
  const { runtimeConfig } = useAppContext();
  const { googleAnalyticsId } = runtimeConfig;
  const { pathname, search } = useLocation();
  const authState = useAuthState();
  const user = authState.user.get()?.displayName;

  React.useEffect(() => {
    if (googleAnalyticsId && pathname) {
      gtag('config', googleAnalyticsId, {
        page_path: pathname + search,
      });
    }
  }, [pathname, search, googleAnalyticsId]);

  return (
    <React.Fragment>
      <AppHeader />
      <Box sx={appBodyStyles}>
        <Switch>
          <Route
            path={routes.createQuote}
            render={() => (
              <PrivateRoute>
                <Quote displayName={user ? user : ''} />
              </PrivateRoute>
            )}
            exact={true}
          />
          <Route
            path={routes.viewQuote}
            render={() => (
              <PrivateRoute>
                <Quote displayName={user ? user : ''} />
              </PrivateRoute>
            )}
            exact={true}
          />
          <Route
            path={routes.listQuotes}
            render={() => (
              <PrivateRoute>
                <ListQuotes />
              </PrivateRoute>
            )}
            exact={true}
          />
          <Route path={routes.login} component={() => <Login />} exact={true} />
          <Route path={routes.unauthorized} component={() => <Unauthorized />} exact={false} />
        </Switch>
        <ToastContainer newestOnTop />
      </Box>
    </React.Fragment>
  );
};
